import React, { Component } from 'react';
import { reduxForm, Field, formValueSelector } from 'redux-form';
import { Grid, Form } from 'semantic-ui-react';
import { connect } from 'react-redux';
import { PropTypes } from 'prop-types';

import { FOOD_BASED_ANALYSIS_FORM_NAME } from 'Common/FormEnum';
import { FoodBasedAnalysisFieldEnum } from 'Common/FieldEnum';
import { SiteSelectField } from 'Common/ReduxFormFields';
import { MenuMealTypesEnum } from 'Common/Constants/Enumeration/MealTypesEnum';
import { DATE_FORMAT_FOR_UI, AnalysisDaysOptions } from 'Common/Constants';
import { AllOptionEnum } from 'Common/Constants/Enumeration/PropEnums';
import { TitledCard } from 'Components/';
import {
  SelectField,
  RangeDatePickerField,
  ButtonGroupField,
} from 'Common/SemanticWrapper';
import {
  makeSelectFieldOptionsFromEnum,
  rangeDateValidator,
} from 'Common/FormHelper';

import {
  SortByOptions,
  ComponentOptions,
  SortByEnum,
} from '../helpers/FoodBasedAnalysisHelpers';

const { ALL, ...mealTypesEnum } = MenuMealTypesEnum;
const mealTypesOptions = makeSelectFieldOptionsFromEnum(mealTypesEnum);

class FoodBasedAnalysisReportFormContainer extends Component {
  static propTypes = {
    nutritionStandards: PropTypes.array,
    nutritionStandardsLoading: PropTypes.bool,
    cycleMenus: PropTypes.array,
    cycleMenusLoading: PropTypes.bool,
    loading: PropTypes.bool,
  };

  static defaultProps = {
    nutritionStandards: [],
    nutritionStandardsLoading: false,
    cycleMenus: [],
    cycleMenusLoading: false,
    loading: false,
  };

  render() {
    const {
      nutritionStandards,
      nutritionStandardsLoading,
      cycleMenus,
      cycleMenusLoading,
      loading,

      sortBy,
    } = this.props;

    return (
      <Form>
        <TitledCard title="Filters">
          <Grid>
            <Grid.Row>
              <Grid.Column width={10}>
                <Field
                  name={FoodBasedAnalysisFieldEnum.Site}
                  component={SiteSelectField}
                  allOption={AllOptionEnum.None}
                  disabled={loading}
                  style={{ marginBottom: '10px' }}
                />
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={10}>
                <RangeDatePickerField
                  fromName={FoodBasedAnalysisFieldEnum.FromDate}
                  toName={FoodBasedAnalysisFieldEnum.ToDate}
                  disabled={loading}
                />
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={10}>
                <Field
                  label="Meal Type"
                  name={FoodBasedAnalysisFieldEnum.MealType}
                  component={SelectField}
                  options={mealTypesOptions}
                  disabled={loading}
                />
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={10}>
                <Field
                  label="Nutrition Standard"
                  name={FoodBasedAnalysisFieldEnum.NutritionStandard}
                  component={SelectField}
                  options={nutritionStandards}
                  loading={nutritionStandardsLoading}
                  disabled={
                    !nutritionStandards.length ||
                    nutritionStandardsLoading ||
                    loading
                  }
                />
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </TitledCard>
        <TitledCard title="Report Parameters">
          <Grid>
            <Grid.Row>
              <Grid.Column width={10}>
                <Field
                  label="Cycle Menu"
                  name={FoodBasedAnalysisFieldEnum.Menu}
                  component={SelectField}
                  options={cycleMenus}
                  loading={cycleMenusLoading}
                  disabled={!cycleMenus.length || cycleMenusLoading || loading}
                />
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={10}>
                <Field
                  label="Number of days"
                  name={FoodBasedAnalysisFieldEnum.NumDays}
                  component={SelectField}
                  type="text"
                  options={AnalysisDaysOptions}
                  fluid
                  upward
                  disabled={loading}
                />
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={5}>
                <Field
                  label="Sort By"
                  component={ButtonGroupField}
                  name={FoodBasedAnalysisFieldEnum.SortBy}
                  fieldName={FoodBasedAnalysisFieldEnum.SortBy}
                  options={SortByOptions}
                  disabled={loading}
                />
              </Grid.Column>
              <Grid.Column width={5}>
                {sortBy === SortByEnum.Component && (
                  <Field
                    label="Component"
                    name={FoodBasedAnalysisFieldEnum.SortByComponent}
                    component={SelectField}
                    type="text"
                    options={ComponentOptions}
                    upward
                    disabled={loading}
                  />
                )}
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </TitledCard>
      </Form>
    );
  }
}

const validate = (values) => {
  const errors = rangeDateValidator(
    values[FoodBasedAnalysisFieldEnum.FromDate],
    values[FoodBasedAnalysisFieldEnum.ToDate],
    {
      granularity: 'day',
      fromName: FoodBasedAnalysisFieldEnum.FromDate,
      toName: FoodBasedAnalysisFieldEnum.ToDate,
      fromLabel: 'From',
      toLabel: 'To',
      dateFormat: DATE_FORMAT_FOR_UI,
      strict: false,
    }
  );

  if (!values[FoodBasedAnalysisFieldEnum.Site]) {
    errors[FoodBasedAnalysisFieldEnum.Site] = 'Site is required';
  }

  if (!values[FoodBasedAnalysisFieldEnum.Menu]) {
    errors[FoodBasedAnalysisFieldEnum.Menu] = 'Cycle Menu is required';
  }

  return errors;
};

const FoodBasedAnalysisReportFormForm = reduxForm({
  form: FOOD_BASED_ANALYSIS_FORM_NAME,
  validate,
})(FoodBasedAnalysisReportFormContainer);

const mapStateToProps = (state) => {
  const selector = formValueSelector(FOOD_BASED_ANALYSIS_FORM_NAME);

  return {
    //https://github.com/redux-form/redux-form/issues/2253
    //https://github.com/redux-form/redux-form/issues/4344
    sortBy: selector(state, [FoodBasedAnalysisFieldEnum.SortBy]),
  };
};

export const FoodBasedAnalysisReportForm = connect(
  mapStateToProps,
  null
)(FoodBasedAnalysisReportFormForm);



// WEBPACK FOOTER //
// ./src/pages/reports/menus/foodbasedanalysisreport/components/FoodBasedAnalysisReportForm.js